import client from '@/api/client';
import { TrialCollectionResponse, TrialGetCollection } from '@/api/dtos';
import { useGet } from '@ngt/forms';
import { SWRConfiguration, SWRResponse } from 'swr';

const request = () => new TrialGetCollection();

const getData = (response?: SWRResponse<TrialCollectionResponse, TrialCollectionResponse>) => response?.data?.data;
const getError = (response?: SWRResponse<TrialCollectionResponse, TrialCollectionResponse>) => (response?.error ?? response?.data)?.responseStatus;

export const useTrials = (configuration?: SWRConfiguration) => {
    return useGet(request, { getData, getError}, configuration);
};

export default useTrials;